import React, { Component } from 'react';
import RuleNavBottom from './RuleNavBottom';
import RuleSwitch from './RuleSwitch';
import baseURL from '../services/api_url';

class RuleFourCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      result: null,
      type: "company",
      rule: 4,
      email: this.props.email
    };
    this.loadCurrentSelect = this.loadCurrentSelect.bind(this);
    this.addOnClickEvent = this.addOnClickEvent.bind(this);
    this.checkSelect = this.checkSelect.bind(this);
    this.updateDataBase = this.updateDataBase.bind(this);
  }

  componentDidMount() {
    this.loadCurrentSelect();
    this.addOnClickEvent();
  }

  loadCurrentSelect() {
    const result = this.props.company.split('');
    const selected = this.props.selected.split('');
    this.setState({
      result: this.props.company,
      selected: this.props.selected,
    })
    const htmlColl = document.getElementsByClassName('rule-block')
    for (let i = 0; i < 6; i ++) {
      if (selected[i] === 't') {
        htmlColl[i].childNodes[result[i]].classList.add('selection');
      }
    }
  }

  updateDataBase() {
    const data = this.state;
    fetch(`${baseURL}/api/result`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify(data)
    })
      .then(() => {
        this.props.getResult();
      })
  }

  updateSelection(e) {
    const newresult = this.state.result.split('');
    const newSelected = this.state.selected.split('');
    let row = e.target.dataset.row;
    let col = e.target.dataset.col
    newresult[row-1] = col;
    newSelected[row-1] = 't';

    const columnName = `${this.state.type}_${this.state.rule}`;
    const columnValue = this.state.result;

    this.props.updateProps(columnName, columnValue);

    this.setState({
      result: newresult.join(''),
      selected: newSelected.join('')
    })
  }

  checkSelect(e) {
    if (e.target.classList[1] !== 'selection') {
      const siblingNodes = e.target.parentNode.childNodes
      for (let i = 0; i < siblingNodes.length; i ++) {
        if (siblingNodes[i].classList[1] === 'selection') {
          siblingNodes[i].classList.remove('selection');
        }
      }
    }

    e.target.classList.add('selection');

    this.updateSelection(e);
  }

  addOnClickEvent() {
    const htmlColl = document.getElementsByClassName('rule-select')
    for (let i = 0; i < htmlColl.length; i ++) {
      htmlColl[i].addEventListener('click', this.checkSelect);
    }
  }

  render() {
    return (
      <div className="center">
        <RuleSwitch updateDataBase={this.updateDataBase} />
        <div className="h-flex rule-cate">
          <div className="border-to-right v-flex">
            <p>Rule Four</p>
            <p>Company Grid</p>
          </div>
          <div className="v-flex">
            <p>0-20%</p>
            <p>Minimal Capability</p>
          </div>
          <div className="v-flex">
            <p>20-40%</p>
            <p>Limited Capability</p>
          </div>
          <div className="v-flex">
            <p>40-60%</p>
            <p> Moderate Capability</p>
          </div>
          <div className="v-flex">
            <p>60-80%</p>
            <p>Advanced Capability</p>
          </div>
          <div className="v-flex">
            <p>80-100%</p>
            <p>World Class Capability</p>
          </div>
        </div>
        <div className="v-flex rule-table">
          <div className="h-flex rule-block">
            <p>Beyond "We Know Everything"</p>
            <div className="rule-select" data-row="1" data-col="1">Our culture is highly resistant to external innovations</div>
            <div className="rule-select" data-row="1" data-col="2">6 of the 8 open innovation inhibitors are still in place</div>
            <div className="rule-select" data-row="1" data-col="3">4 of the 8 open innovation inhibitors are still in place</div>
            <div className="rule-select" data-row="1" data-col="4">2 of the 8 open innovation inhibitors are still in place</div>
            <div className="rule-select" data-row="1" data-col="5">All 8 open innovation inhibitors have been resolved</div>
          </div>
          <div className="h-flex rule-block">
            <p>Multiple innovation channels</p>
            <div className="rule-select" data-row="2" data-col="1">Zero or 1 of the open innovation channels have been activated</div>
            <div className="rule-select" data-row="2" data-col="2">2 of the 8 open innovation channels have been activated</div>
            <div className="rule-select" data-row="2" data-col="3">4 of the 8 open innovation channels have been activated</div>
            <div className="rule-select" data-row="2" data-col="4">6 of the 8 open innovation channels have been activated</div>
            <div className="rule-select" data-row="2" data-col="5">All 8 open innovation channels have been activated</div>
          </div>
          <div className="h-flex rule-block">
            <p>Right gives and gets</p>
            <div className="rule-select" data-row="3" data-col="1">The vast majority of the ideas in our innovation funnel come from internal sources</div>
            <div className="rule-select" data-row="3" data-col="2">At least 10% of the ideas in our innovation funnel come from external sources</div>
            <div className="rule-select" data-row="3" data-col="3">At least 30% of the ideas in our innovation funnel come from external sources</div>
            <div className="rule-select" data-row="3" data-col="4">At least 50% of the ideas in our innovation funnel come from external sources</div>
            <div className="rule-select" data-row="3" data-col="5">Over 70% of the ideas in our innovation funnel come from external sources</div>
          </div>
          <div className="h-flex rule-block">
            <p>Easy to innovate with</p>
            <div className="rule-select" data-row="4" data-col="1">We are just starting out and none of the 8 best practices describe our company today</div>
            <div className="rule-select" data-row="4" data-col="2">At least 2 of the 8 best practices apply to how we run our innovation network</div>
            <div className="rule-select" data-row="4" data-col="3">At least 4 of the 8 best practices apply to how we run our innovation network</div>
            <div className="rule-select" data-row="4" data-col="4">At least 6 of the 8 best practices apply to how we run our innovation network</div>
            <div className="rule-select" data-row="4" data-col="5">Every one of the 8 best practices apply to how we run our innovation network</div>
          </div>
          <div className="h-flex rule-block">
            <p>Robust innovation sandbox</p>
            <div className="rule-select" data-row="5" data-col="1">We do not yet allow external access to sample data or our technology</div>
            <div className="rule-select" data-row="5" data-col="2">Innovation sandbox is built on a one-off basis for specific external partners</div>
            <div className="rule-select" data-row="5" data-col="3">Substantial sample data is available for startups to experiment with</div>
            <div className="rule-select" data-row="5" data-col="4">Have now extended beyond data toward API-based access to our technology</div>
            <div className="rule-select" data-row="5" data-col="5">Deep APIs, massive sample data sets, and valuable technology available today</div>
          </div>
          <div className="h-flex rule-block">
            <p>Corporate development toolkit</p>
            <div className="rule-select" data-row="6" data-col="1">We do not have a formal Corporate Development capability today</div>
            <div className="rule-select" data-row="6" data-col="2">We have limited, ad hoc experience in Corporate Development today</div>
            <div className="rule-select" data-row="6" data-col="3">We have substantial experience in 2 of the 6 Corporate Development tools</div>
            <div className="rule-select" data-row="6" data-col="4">We have substantial experience in 4 of the 6 Corporate Development tools</div>
            <div className="rule-select" data-row="6" data-col="5">We have substantial experience in each of the 6 Corporate Development tools</div>
          </div>
        </div>
        <br />
        <div className="center">
          <RuleNavBottom updateDataBase={this.updateDataBase} />
        </div>
      </div>
    )
  }
}

export default RuleFourCompany;
